import CollapsableCard from "../../../components/CollapseableCard";
import LineItem from "../../../components/NewDetail/views/OrderTabs/Invoice/LineItem";
import LineItemInput from "../../../components/NewDetail/views/OrderTabs/Invoice/LineItemInput";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import useEditInvoiceForOrder from "../../../hooks/useEditInvoiceForOrder";
import {
  Button,
  Box,
  Typography,
  Link,
  ListItem,
  ListItemText,
  FormHelperText,
  Card,
  TextField,
  MenuItem,
  Fab,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import QbCustomers from "../../../components/NewDetail/views/OrderTabs/Invoice/QbCustomers";
import { toTwoDecimals } from "../../../components/NewDetail/calculations/utils";
import ExistingInvoices from "../../../components/NewDetail/views/OrderTabs/Invoice/ExistingInvoices";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import SelectPaymentMethod from "./SelectPaymentMethod";
import SelectDepositAccount from "./SelectDepositAccount";
import { SnackAlertContext } from "../../../context/SnackAlertContext";

import moment from "moment-timezone";
import InvoicePayment from "./InvoicePayment";
import OrderTitle from "../../../components/OrderTitle";
import SelectQuickbooksCustomer from "./SelectQuickbooksCustomer";
import SendInvoiceDialog from "./SendInvoiceDialog";
import ConfirmPaidDialog from "./ConfirmPaidDialog";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

const InvoiceDetails = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { openSnackMessage } = useContext(SnackAlertContext);
  const [order, setOrder] = useState(null);
  const [dueDate, setDueDate] = useState(
    dayjs().tz(DEFAULT_TIMEZONE).endOf("day")
  );
  const {
    lineItems,
    addLineItem,
    newLineItem,
    handleNewLineItemChange,
    serviceOptions,
    submitInvoice,
    removeLineItem,
    isSubmitting,
  } = useEditInvoiceForOrder(orderId);
  const { authToken, ezorder } = useContext(AuthContext);
  const [sendInvoiceDialogOpen, setSendInvoiceDialogOpen] = useState(false);
  const [confirmPaidDialogOpen, setConfirmPaidDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [invoiceLink, setInvoiceLink] = useState("");
  const [invoice, setInvoice] = useState(null);
  const [qbCustomerId, setQbCustomerId] = useState(null);
  const [paymentDate, setPaymentDate] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [paymentReferenceNumber, setPaymentReferenceNumber] = useState(null);
  const [paymentDepositAccount, setPaymentDepositAccount] = useState(false);
  const [relatedInvoices, setRelatedInvoices] = useState([]);
  const [paymentLines, setPaymentLines] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [depositAccounts, setDepositAccounts] = useState([]);

  const getOrderById = async (id) => {
    try {
      // setLoading(true);
      // REMOVE ID from Default Variables because we're just copying the values
      // This object is added to pieces if their variable property is null

      const response = await ezorder.get(`/admin/orders/${id}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      // console.log("API Response: ", response.data.order);
      if (response.status === 200 || response.status == 201) {
        setOrder(response.data.order);

        // set invoice due date based on customer
        let customer = response.data.order.company;
        if (customer.creditType === "Credit Terms") {
          // If Credit Terms, Check use the Net days
          switch (customer.creditTerms) {
            case "Net 30":
              setDueDate(
                dayjs().tz(DEFAULT_TIMEZONE).add(30, "days").endOf("day")
              );
              break;
            case "Net 45":
              setDueDate(
                dayjs().tz(DEFAULT_TIMEZONE).add(45, "days").endOf("day")
              );
              break;
            case "Net 60":
              setDueDate(
                dayjs().tz(DEFAULT_TIMEZONE).add(60, "days").endOf("day")
              );
              break;
            default:
              setDueDate(dayjs().tz(DEFAULT_TIMEZONE).endOf("day"));
              break;
          }
        } else {
          // Default due date to 1 month?? Ask Kerry and Matt
          setDueDate(dayjs().tz(DEFAULT_TIMEZONE).endOf("day"));
        }
      }
    } catch (error) {
      console.log(error);
      //   setError(error);
    } finally {
      setLoading(false);
    }
  };

  const createInvoiceBody = (qbCustomerId, lineItems) => {
    const items = lineItems.map((item) => ({
      DetailType: "SalesItemLineDetail",

      Amount: parseFloat(parseFloat(item.amount).toFixed(1)),
      Description: item.description,
      SalesItemLineDetail: {
        Qty: parseFloat(parseFloat(item.qty).toFixed(1)),
        ServiceDate: dayjs(item.serviceDate).format(),
        ItemRef: {
          name: item.service.Name,
          value: item.service.Id,
        },
        TaxCodeRef: {
          value: item.isTaxed ? "TAX" : "NON",
        },
      },
    }));
    return {
      DueDate: dueDate.format("YYYY-MM-DD"),
      Line: [...items],
      CustomerRef: { value: `${qbCustomerId}` },
    };
  };

  const handleSubmit = () => {
    const invoiceData = createInvoiceBody(qbCustomerId, lineItems);
    let body = {
      invoiceData,
      orderId: order.id,
    };
    console.log(body);
    submitInvoice(body);
  };

  const getInvoiceDetails = async (controller) => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        data.signal = controller.signal;
      }

      const response = await ezorder.get(
        `/admin/orders/${order.id}/invoice`,
        data
      );

      setInvoice(response.data.invoice);
      setInvoiceLink(response.data.invoice.InvoiceLink);
      setPaymentLines([response.data.invoice]);
    } catch (error) {
      console.log("Failed To Load Invoice for Order", order.id);
    } finally {
      setLoading(false);
    }
  };

  const getPaymentMethods = async (controller) => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        data.signal = controller.signal;
      }

      const response = await ezorder.get(`/quickbooks/payment-methods`, data);

      setPaymentMethods(response.data.paymentMethods);
    } catch (error) {
      console.log("Failed To Load Payment Methods");
    } finally {
      setLoading(false);
    }
  };
  const getDepositAccounts = async (controller) => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        data.signal = controller.signal;
      }

      const response = await ezorder.get(`/quickbooks/accounts`, data);

      setDepositAccounts(response.data.accounts);
    } catch (error) {
      console.log("Failed To Load Payment Methods");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPaymentMethods();
    getDepositAccounts();
  }, []);

  const getAllRelatedInvoicesByCustomer = async () => {
    try {
      setLoading(true);
      const response = await ezorder.get(
        `/quickbooks/invoice/${order.invoiceId}/related`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      console.log(response);
      setRelatedInvoices(response.data.invoices);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (order && order.invoiceId) getAllRelatedInvoicesByCustomer();
  }, [order]);

  useEffect(() => {
    // console.log("OrderTableRow useEffect()");
    const controller = new AbortController();
    if (order && order.invoiceId) {
      getInvoiceDetails(controller);
    }

    return () => {
      controller.abort(); // abort api call on unmount for cleanup
    };
  }, [order]);

  useEffect(() => {
    getOrderById(orderId);
  }, [orderId]);

  if (!order) return null;

  if (order && order.invoiceId && order.invoiceCustomerRefName) {
    return (
      <Box sx={{ paddingBottom: "200px" }}>
        <Box sx={{ flex: 1 }}>
          <OrderTitle order={order} includeStatus={true} />
        </Box>
        <Typography variant="h5" sx={{ textAlign: "center" }}>
          Invoice
        </Typography>
        <Box sx={{ padding: "16px" }}>
          {invoice ? (
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Box sx={{}}>
                <Typography sx={{ fontWeight: "bold" }}>Details</Typography>
                Subcustomer:{" "}
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  href={invoice.InvoiceLink}
                >
                  {invoice.CustomerRef.name}
                </Link>
                <Typography>Invoice #{invoice.DocNumber}</Typography>
                <Typography>Invoice Date: {invoice.TxnDate}</Typography>
                <Typography>Due Date: {invoice.DueDate}</Typography>
                <Typography>
                  Balance: ${toTwoDecimals(invoice.Balance)}
                </Typography>
                <Typography>Email Status: {invoice.EmailStatus}</Typography>
                <Typography>Bill Email: {invoice.BillEmail.Address}</Typography>
              </Box>
              {invoice.BillAddr && (
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontWeight: "bold" }}>
                    Billing Address
                  </Typography>
                  <Typography>{invoice.BillAddr.Line1}</Typography>
                  <Typography>{invoice.BillAddr.Line2}</Typography>
                  <Typography>
                    {invoice.BillAddr.City},{" "}
                    {invoice.BillAddr.CountrySubDivisionCode}{" "}
                    {invoice.BillAddr.PostalCode}
                  </Typography>
                </Box>
              )}
            </Box>
          ) : (
            <>
              <Typography>
                Could not find invoice details on quickbooks. Please check that
                this invoice was not voided or deleted on Quickbooks
              </Typography>
              Link <a href={invoiceLink}>{order.invoiceCustomerRefName}</a>
            </>
          )}
        </Box>
        {/* <Box sx={{ marginTop: "32px" }}>
          <CollapsableCard
            title="Change Assiged Invoice For this Order"
            defaultOpen={false}
          >
            <FormHelperText>
              Make sure the sub-customer reference name is unique. The same
              invoice cannot be used for multiple orders
            </FormHelperText>
            <ExistingInvoices
              orderId={order.id}
              // updateOrder={updateOrder}
            />
          </CollapsableCard>
        </Box> */}
        <Card sx={{ padding: "16px", marginTop: "32px" }}>
          <Typography
            variant="h5"
            sx={{
              marginBottom: "0px",
              paddingBottom: "0px",
            }}
          >
            Invoice Transaction History
          </Typography>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Ref No.</TableCell>
                  <TableCell>Deposit to Account</TableCell>
                  <TableCell>Payment Total</TableCell>
                  <TableCell>Amount Applied To This Invoice</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoice &&
                  invoice.LinkedTxn &&
                  invoice.LinkedTxn.map((txn, index) => {
                    if (txn.TxnType == "Payment") {
                      return (
                        <InvoicePayment
                          key={index}
                          id={txn.TxnId}
                          invoice={invoice}
                          paymentMethods={paymentMethods}
                          depositAccounts={depositAccounts}
                        />
                      );
                    }
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <Box></Box>
        </Card>
        <Box
          style={{
            position: "fixed",
            bottom: "20px",
            right: "50px",
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          <Fab
            disabled={loading}
            variant="extended"
            color="success"
            onClick={() => {
              navigate(`/invoices/${orderId}/receive-payment`);
            }}
          >
            Receive Payment (Cash or Check)
          </Fab>
          <Fab
            disabled={loading}
            variant="extended"
            color="success"
            onClick={() => {
              window.open(invoiceLink, "_blank");
            }}
          >
            Receive Payment (Debit, Credit, or ACH)
          </Fab>
          <Fab
            disabled={loading}
            variant="extended"
            color="success"
            onClick={() => {
              setSendInvoiceDialogOpen(true);
            }}
          >
            Send Invoice
          </Fab>
          {!order.isPaid && (
            <Fab
              disabled={loading}
              variant="extended"
              color="success"
              onClick={() => {
                setConfirmPaidDialogOpen(true);
              }}
            >
              Mark Order as Paid
            </Fab>
          )}
        </Box>
        {invoice && (
          <SendInvoiceDialog
            invoiceId={invoice.Id}
            docNumber={invoice.DocNumber}
            subCustomer={invoice.CustomerRef.name}
            currentBillingEmail={invoice.BillEmail.Address}
            open={sendInvoiceDialogOpen}
            onClose={() => {
              setSendInvoiceDialogOpen(false);
            }}
            onSend={() => {
              setSendInvoiceDialogOpen(false);
              openSnackMessage("success", "Invoice Sent!");
              getInvoiceDetails(); // refresh invoice
            }}
          />
        )}
        <ConfirmPaidDialog
          orderId={orderId}
          open={confirmPaidDialogOpen}
          onClose={() => {
            setConfirmPaidDialogOpen(false);
          }}
          onConfirm={() => {
            setConfirmPaidDialogOpen(false);
            openSnackMessage("success", "Payment Status Updated");
            getOrderById(orderId); // refresh invoice
          }}
        />
      </Box>
    );
  }

  if (
    !order.invoiceId &&
    (order.orderStatus.name === "ESTIMATE_APPROVED" ||
      order.orderStatus.name === "PENDING_PAYMENT" ||
      order.orderStatus.name === "IN_PROGRESS" || // Allow adding an invoice if this was skipped
      order.orderStatus.name === "READY_FOR_PICKUP" ||
      order.orderStatus.name === "CLOSED")
  ) {
    return (
      <Box>
        <Box sx={{ flex: 1 }}>
          <OrderTitle order={order} includeStatus={true} includeLink={true} />
        </Box>
        <Box>
          <Typography variant="h5" sx={{ textAlign: "center" }}>
            Create Invoice
          </Typography>

          <Box sx={{ marginTop: "16px" }}>
            <Typography variant="h6">Select Quickbooks Customer</Typography>
            <SelectQuickbooksCustomer
              qbCustomerId={qbCustomerId}
              onSelect={(qbCustomer) => {
                setQbCustomerId(qbCustomer);
              }}
            />
            {qbCustomerId && (
              <Box sx={{ marginTop: "16px" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    // shouldDisableDate={(date) => {
                    //   return date.tz(DEFAULT_TIMEZONE).day() != 1; // Monday Only
                    // }}
                    inputFormat="ddd MM/DD/YY" // display format
                    label="Due Date"
                    // BY DEFAULT, DAYJS.format() will format in local time and not UTC
                    // So the YYYY-MM-DD we're parsing out will be accurate
                    value={dueDate}
                    onChange={(newValue) => {
                      setDueDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        sx={{ width: "200px" }}
                        {...params}
                      />
                    )}
                  />
                </LocalizationProvider>
                <Typography variant="h6">Invoice Items</Typography>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell sx={{ minWidth: "200px" }}>
                          SERVICE DATE
                        </TableCell>
                        <TableCell sx={{ minWidth: "120px" }}>
                          PRODUCT/SERVICE
                        </TableCell>
                        <TableCell sx={{ minWidth: "600px" }}>
                          DESCRIPTION
                        </TableCell>
                        <TableCell sx={{ minWidth: "100px" }}>QTY</TableCell>
                        <TableCell sx={{ minWidth: "150px" }}>RATE</TableCell>
                        <TableCell sx={{ minWidth: "150px" }}>AMOUNT</TableCell>
                        <TableCell>TAX</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {lineItems.map((lineItem, index) => (
                        <LineItem
                          key={index}
                          lineItem={lineItem}
                          number={index + 1}
                          removeLineItem={() => removeLineItem(index)}
                        />
                      ))}
                      <LineItemInput
                        services={serviceOptions}
                        inputData={newLineItem}
                        handleChange={handleNewLineItemChange}
                        submit={addLineItem}
                      />
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "2rem",
                  }}
                >
                  <Box
                    sx={{
                      marginLeft: "auto",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Button
                      color="success"
                      disabled={
                        lineItems.length < 1 || !qbCustomerId || isSubmitting
                      }
                      variant="outlined"
                      // sx={{ marginLeft: "auto" }}
                      onClick={handleSubmit}
                    >
                      {isSubmitting
                        ? "Loading..."
                        : "Create Invoice In quickbooks"}
                    </Button>
                    {!qbCustomerId && (
                      <Typography
                        textAlign={"center"}
                        variant="caption"
                        sx={{ color: "#c0c1c2" }}
                      >
                        Must Select QB Customer First
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
          {/* <Typography variant="h5">
            OR Assign An Existing Invoice to this Order
          </Typography>
          <ExistingInvoices
            orderId={order.id}
            //   updateOrder={updateOrder}
          /> */}
        </Box>
      </Box>
    );
  } else {
    return null;
  }
};
export default InvoiceDetails;
